export const LOG_OUT = 'LOG_OUT';
export const SET_USER = 'SET_USER';

export const CREATE_ALERT = 'CREATE_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const CLEAR_SPINNERS = 'CLEAR_SPINNERS';